module.exports = __webpack_public_path__ + "img/login.20a9e781.png";